var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h4',[_vm._v("Összes tartozás")]),_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}]},[_vm._v(_vm._s(_vm._f("currency")(_vm.sum)))])])}
var staticRenderFns = []

export { render, staticRenderFns }